import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContactPersonModel } from './contact-person.model';
import { IonicModule } from '@ionic/angular';

@Component({
  imports: [IonicModule],
  selector: 'contact-person-preview',
  standalone: true,
  styleUrls: ['../../person/@shared/person-preview/person-preview.component.scss'],
  template: `
    <ion-item button [disabled]="!item" (click)="openDetail.emit(item)">
      <div class="item-start" slot="start">
        <ng-content></ng-content>
        <ion-icon name="person-outline"></ion-icon>
      </div>
      <ion-label class="ion-text-wrap item-label">
        <h3 class="item-label__title"><span class="skeleton">{{ item?.personDisplayName || '████████' }}</span></h3>
        <p class="item-label__subheadline"><span class="skeleton">{{ item?.organizationName || '████████' }}</span></p>
        @if (item?.email) { <p>{{ item.email }}</p> }
        @if (item?.phoneNumber) { <p>{{ item.phoneNumber }}</p> }
      </ion-label>
    </ion-item>
  `,
})
export class ContactPersonPreviewComponent {
  @Input() public item: ContactPersonModel | null;
  @Output() public openDetail = new EventEmitter<ContactPersonModel>();
}
